import { Input } from 'sonata-react-components';

import type { AdInterface } from 'sonata-static-storage/lib/schemas/ad/ad.schema';
import type { BaseCurrencyInterface } from 'sonata-static-storage/lib/schemas/baseCurrency/baseCurrency.schema';

import './AdPrice.scss';

type Props = {
  ad: AdInterface;
  bidPrice?: string | number;
  id: string;
  defaultValue?: number;
  baseCurrency: BaseCurrencyInterface;
  onChange: (value: string | FileList | null) => void;
};

export function AdPrice({ ad, baseCurrency, bidPrice, id, onChange }: Props) {
  const bidPriceNumber = typeof bidPrice === 'number' ? bidPrice : 0;

  return (
    <div className="adPrice">
      <Input
        className="adPrice__input"
        currencyConfig={baseCurrency}
        disabled={ad.deleted || !ad.visible}
        id={`${id}-budget`}
        name={`${id}-budget`}
        notFloatingPlaceholder
        numberFormat="currency"
        numberOfDecimals={2}
        onChange={value => onChange(value)}
        shape="squareUI"
        tiny
        type="number"
        value={bidPriceNumber}
      />
    </div>
  );
}
